import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import styles from "./appointments.module.scss";
import { RootState } from "../../../../store";
import { getAppointments, getRcBranches } from "../../../../slices/clientPortalUserInfoSlice";
import BookAppointments from "./book-appointments";
import ServiceProviderSelect from "./serviceproviders-select";
import BranchSelect from "./branch-select";
import { getServices } from "../../../../actions/services";

const today = new Date();

const Appointments = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const clientPortalInfo = useSelector((state: RootState) => state.clientPortalUserInfo.user);
  const [step, setStep] = React.useState<number>(0);
  const rcId = useSelector((state: RootState) => state.clientPortalUserInfo.resourceCentreId);
  const services = useSelector((state: RootState) => state.services.collection);

  React.useEffect(() => {
    if (rcId) {
      dispatch(getRcBranches(rcId));
    }
  }, [dispatch, rcId]);

  React.useEffect(() => {
    if (!services || !services.length) {
      dispatch(getServices());
    }
  }, [services, dispatch]);

  React.useEffect(() => {
    if (clientPortalInfo?.user.id) {
      dispatch(
        getAppointments({
          clientId: clientPortalInfo.user.id,
          from: moment(today).startOf("day").toISOString(),
          to: moment(today).endOf("day").add(7, "days").toISOString()
        })
      );
    }
  }, [dispatch, clientPortalInfo?.user.id]);

  return (
    <div className={styles.appointmentContainer}>
      <div className={styles.cardContainer}>
        {step === 0 && <BranchSelect onSelectStep={(s) => setStep(s)} />}
        {step === 1 && <ServiceProviderSelect />}
        {step === 2 && <BookAppointments />}
      </div>
    </div>
  );
};

export default Appointments;
